import React from 'react';

// TODO mark
export const TransparentLoader = () => (
  <div
    className="fixed left-0 bottom-0 z-1000001 h-full w-full overflow-hidden"
    style={{
      background: 'rgba(255, 255, 255, .8)',
    }}
  >
    <div className="flex relative justify-center items-center h-full w-full">
      <button className="button--loading border-primary-1 h-40" />
    </div>
  </div>
);
